module.exports = __webpack_public_path__ + "static/img/GoldenMahjong2.60b3bcab.png";